import { assoc, propOr } from "ramda";

class PageStore {
  constructor() {
    this.store = {};
  }

  getCurrentPage(materialId) {
    return propOr(1, materialId, this.store);
  }

  setCurrentPage(materialId, currentPage) {
    this.store = assoc(materialId, currentPage, this.store);
  }
}

const instance = new PageStore();

export default Object.seal(instance);
